import { StyledTableWrapper } from "components/Common/Table/StyledTable.styles.ts";
import SortableTableHead, { HeadCell } from "components/Common/Table/SortableTableHead.tsx";
import { TableBody } from "@mui/material";
import { models } from "types/api/viewModels.ts";
import { FilteredRequestsTableWrapper } from "components/CustomQuote/CustomQuoteRequestTable.styles.ts";
import { useHandleTableSort } from "hooks/useHandleTableSort.ts";
import { useMemo } from "react";
import { BillToAckEmailText, BillToNameText, BillToNumberText, BillToPricingFormatText } from "constants/text.ts";
import { AccountBillToTableRow } from "pages/Preferences/Accounts/AccountBillToPage/components/AccountBillToTableRow/AccountBillToTableRow.tsx";

interface AccountBillToTableProps {
	billTos: models["BillToViewModel"][];
}

const headCells: HeadCell[] = [
	{ id: "projectName", label: BillToNameText, sortable: true, disablePadding: false, numeric: false },
	{ id: "billToId", label: BillToNumberText, sortable: false, disablePadding: false, numeric: false },
	{ id: "email", label: BillToAckEmailText, sortable: false, disablePadding: false, numeric: false },
	{ id: "pricingFormat", label: BillToPricingFormatText, sortable: false, disablePadding: false, numeric: false },
	{ id: "open", label: "", sortable: false, disablePadding: false, numeric: false }
];

export const AccountBillToTable = ({ billTos }: AccountBillToTableProps) => {
	const { getComparator, handleRequestSort, order, orderBy } = useHandleTableSort("projectName", "asc");

	const sortedBillTos = useMemo(() => {
		return billTos?.slice().sort(getComparator(order, orderBy)) ?? [];
	}, [billTos, getComparator, order, orderBy]);

	return (
		<FilteredRequestsTableWrapper>
			<StyledTableWrapper
				data-testid="bill-to-table"
				aria-label="Bill To Table"
			>
				<SortableTableHead
					orderBy={orderBy}
					order={order}
					onRequestSort={handleRequestSort}
					headCells={headCells}
				/>
				<TableBody>
					{sortedBillTos?.map((billTo) => (
						<AccountBillToTableRow
							billTo={billTo}
							key={`${billTo.billToId} - ${billTo.projectName}`}
						/>
					))}
				</TableBody>
			</StyledTableWrapper>
		</FilteredRequestsTableWrapper>
	);
};
